import React, { useEffect, useState, useRef, useCallback } from "react";
import io from "socket.io-client";
import MathJax from "react-mathjax2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Camera } from "react-camera-pro";
import Cropper from "react-cropper";
import SendIcon from "@mui/icons-material/Send";
import MicNoneIcon from "@mui/icons-material/MicNone";
import AddIcon from "@mui/icons-material/Add";
import NorthIcon from "@mui/icons-material/North";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import "cropperjs/dist/cropper.css";
import FreeFinish from "./FreeFinish";
import FreeFinish2 from "./FreeFinish2.js";
import {
  initMixpanel,
  setMixPanelDefaultProperties,
  trackEvent,
} from "./mixPanel.js";
import { useParams } from "react-router-dom";
import {
  ask_another_doubt,
  attach_icon,
  cancel_attach,
  cancel_image,
  click_photo,
  explain_step,
  followup_question,
  no_feedback,
  other_Suggestion,
  SendButton,
  submit_image,
  Suggestion_1st,
  Suggestion_2nd,
  type_doubts,
  upload_document,
  yes_feedback,
} from "./mixPanelEventConstant.js";
import Loader from "./Loder";
import ReCAPTCHA from "react-google-recaptcha";
import { isAllowedAttachment } from "../utils/fileValidation";
import { useTheme } from "../hooks/useTheme";

const apiUrl = process.env.REACT_APP_API_URL || "https://localhost:3600";
const socket = io(apiUrl, {
  transports: ["websocket", "polling"],
  autoConnect: false,
});

const Home = () => {
  const [returningApiKey, setReturningApiKey] = useState("");
  const [textQuestion, setTextQuestion] = useState("");
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState("");
  const [queries, setQueries] = useState([]);
  const [selectedLine, setSelectedLine] = useState("");
  const [visibleSteps, setVisibleSteps] = useState({});
  const [stopRendering, setStopRendering] = useState(false);
  const [followUpData, setFollowUpData] = useState("");
  const [showCropArea, setShowCropArea] = useState(false);
  const [commonQuestionSolutions, setCommonQuestionSolutions] = useState({});
  const [commonProcessing, setCommonProcessing] = useState("");
  const [followupResponses, setFollowupResponses] = useState({});
  const [followupInputQuestion, setFollowupInputQuestion] = useState({});
  const [followupQuestion, setFollowupQuestion] = useState("");
  const [feedbackShow, setFeedbackShow] = useState(true);
  const [feedbackDataShow, setFeedbackDataShow] = useState(false);
  const [thanksFeedBack, setThanksFeedBack] = useState(false);
  const recaptchaRef = useRef(null);
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [showRecaptchaModal, setShowRecaptchaModal] = useState(false);
  const [isValidUser, setIsValidUser] = useState(true);
  const [image, setImage] = useState(null);
  const [orgFileName, setOrgFileName] = useState("");
  const [hasCamera, setHasCamera] = useState(false);
  const [permissionDenied, setPermissionDenied] = useState(true);
  const [alertMessage, setAlertMessage] = useState("");
  const [doubtId, setDoubtId] = useState("");
  const cropperRef = useRef(null);
  const fileInputRef = useRef(null);
  const cameraRef = useRef(null);
  const cancelButtonRef = useRef(null);
  const explanationRefs = useRef([]);
  const [showModal, setShowModal] = useState(false);
  const [FreeDoubt, setFreeDoubt] = useState(null);
  const [codeSnippet, setCodeSnippet] = useState(null);
  const useOld = false;
  const [notLogin, setNotLogin] = useState(true);
  const [freeFinishProps, setFreeFinishProps] = useState({});
  const [submissionSource, setSubmissionSource] = useState(null); // Added state
  const [showAttachMenu, setShowAttachMenu] = useState(false);
  const attachMenuRef = useRef(null);
  const { isDark, toggleTheme } = useTheme();

  const mathJaxConfig = {
    tex2jax: {
      inlineMath: [
        ["$", "$"],
        ["\\(", "\\)"],
      ],
      displayMath: [
        ["$$", "$$"],
        ["\\[", "\\]"],
      ],
      processEscapes: true,
    },
    TeX: {
      extensions: ["AMSmath.js", "AMSsymbols.js"],
    },
  };

  const SafeMathJaxText = ({ content }) => {
    const sanitizeLatex = (text) => {
      if (!text) return "";
      return text
        .replace(/\\\\/g, "\\")
        .replace(/\s*\$\s*/g, "$")
        .replace(/\\vec\s*{([^}]*)}/g, "\\vec{$1}")
        .replace(/\\hat\s*{([^}]*)}/g, "\\hat{$1}")
        .trim();
    };
    return <MathJax.Text text={sanitizeLatex(content)} />;
  };

  const [partnerData, setPartnerData] = useState({
    Name: "",
    Questions: [],
    blankSubtitle: "Upload Your Screenshot and Get a Quick Solution!",
    blankTitle: "Unlock Learning with 24×7 Doubt Support",
    doubtIcon: "/logoFrame.png",
    placeholderText: "Ask me anything",
    showAttachments: true,
    showFeedback: true,
    showQuestionImages: true,
    EmailId: "",
    ImageUrl: "",
  });

  const handleSocketEmit = async (eventName, data) => {
    // try {
    // if (eventName !== "login" && !data.recaptchaToken) {
    //   console.error(`No recaptchaToken for ${eventName}, aborting emission`);
    //   toast.error("Please complete verification");
    //   return;
    // }
    socket.emit(eventName, { ...data });
    // } catch (error) {
    //   console.error(`Error in handleSocketEmit for ${eventName}:`, error);
    //   toast.error("Failed to process request");
    // }
  };

  const handleSocketInit = async () => {
    socket.connect();
  };

  useEffect(() => {
    if (process.env.REACT_APP_UI_PREVIEW === "1") return;
    console.log("Initializing socket connection...");
    handleSocketInit();
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_UI_PREVIEW !== "1") return;
    setNotLogin(false);
    setReturningApiKey("ui-preview");
    setPartnerData((prev) => ({
      ...prev,
      Name: "AI Chat",
      placeholderText: "Ask me anything",
      primaryColor: "hsla(224, 73%, 49%, 1)",
      showAttachments: 1,
      showFeedback: 1,
      showQuestionImages: 0,
    }));
  }, []);

  useEffect(() => {
    if (!showAttachMenu) return;
    const onPointerDown = (e) => {
      if (attachMenuRef.current && !attachMenuRef.current.contains(e.target)) {
        setShowAttachMenu(false);
      }
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("touchstart", onPointerDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("touchstart", onPointerDown);
    };
  }, [showAttachMenu]);

  useEffect(() => {
    const handleAskQuestionMessage = (event) => {
      if (event.data?.event === "ask_question" && event.data?.question) {
        const plainText = new DOMParser().parseFromString(
          event.data.question,
          "text/html",
        ).body.textContent.trim();

        setImage(null);
        setShowCropArea(false);
        setTextQuestion(plainText.slice(0, maxLength));
      }
    };
    window.addEventListener("message", handleAskQuestionMessage);
    return () =>
      window.removeEventListener("message", handleAskQuestionMessage);
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const apiKey = urlParams.get("key");
    const educatorId = urlParams.get("edu");
    const studentId = urlParams.get("stu");
    const token = urlParams.get("token");
    initMixpanel();
    let startTime = Date.now();
    socket.on("ack", () => {
      console.log("Socket id " + socket.id + " Ack on", Date.now());
      if (apiKey) {
        let payload = {
          apiKey: apiKey,
        };
        if (educatorId) payload.educatorId = educatorId;
        if (studentId) payload.studentId = studentId;
        if (token) payload.token = token;
        handleSocketEmit("login", payload);
      }
    });

    // socket.on("cf_turnstile_error", () => {
    //   setIsValidUser(false);
    // });

    socket.on("trial-expire", (message) => {
      if (message) {
        stopRenderingHandler();
        allClear();
        setShowModal(true);
        setFreeDoubt(message.data.FreeDoubt);
        setCodeSnippet(message.data.codeSnippet);
      }
    });

    socket.on("login-success", (message) => {
      if (message.status === true) {
        setNotLogin(false);
        const { apiKey, Partner } = message;
        const questions =
          Partner?.Questions?.length > 0
            ? Partner?.Questions
            : ["", "", "", ""];
        setPartnerData({ ...Partner, Questions: questions });
        setReturningApiKey(message.apiKey);
        setFreeFinishProps({
          ApiKey: Partner.ApiKey,
          studentId: message.studentId,
        });
        setMixPanelDefaultProperties({
          partnerKey: Partner.ApiKey,
          studentId: message.studentId,
          educatorId: message.educatorId,
          partnerId: Partner.mongoId,
        });
      }
    });

    socket.on("processing-status", (data) => {
      if (data.status) {
        setProcessing(data.status);
        setLoading(true);
      }
    });

    socket.on("query-response-solution", (data) => {
      setQueries((prevQueries) => {
        const updatedQueries = [...prevQueries];
        updatedQueries[updatedQueries.length - 1].solution = data.content;
        return updatedQueries;
      });
      setLoading(false);
    });

    // socket.on("image-url", (imageUrl) => {
    //   setQueries((prevQueries) => {
    //     const updatedQueries = [...prevQueries];
    //     updatedQueries[updatedQueries.length - 1].imageUrl = imageUrl;
    //     return updatedQueries;
    //   });
    //   setImage(null);
    // });

    socket.on("question-text", (question) => {
      if (question) {
        setStopRendering(false);
      }
      setQueries((prevQueries) => {
        const updatedQueries = [...prevQueries];
        if (updatedQueries.length > 0) {
          updatedQueries[updatedQueries.length - 1].question = question;
        }
        return updatedQueries;
      });
    });

    socket.on("query-update-solution", (chunk) => {
      if (!stopRendering) {
        setLoading(false);
        setQueries((prevQueries) => {
          const updatedQueries = [...prevQueries];
          updatedQueries[updatedQueries.length - 1].solution += chunk.chunk;
          return updatedQueries;
        });
      }
    });

    socket.on("final-solution", (data) => {
      if (data.status) {
        setLoading(false);
      }
      setDoubtId(data?.dountId ? data?.dountId : "");
      setFeedbackShow(false);
      setFeedbackDataShow(true);
      setImage(null);
    });

    socket.on("common-question-solution", (chunk) => {
      const { indexValue, commonSolution } = chunk;
      setCommonQuestionSolutions((prev) => ({
        ...prev,
        [indexValue]: commonSolution,
      }));
      setCommonProcessing("");
    });

    socket.on("doubt-end", () => {
      sendDataToAndroid();
      sendDataToFlutter();
    });

    socket.on("common-question-processing", (data) => {
      if (data.status) {
        setCommonProcessing(data.status);
      }
    });

    socket.on("followup-query-user", (data) => {
      setFollowupResponses((prevResponses) => {
        const updatedResponses = { ...prevResponses };
        if (!updatedResponses[data.followCompositeKey]) {
          updatedResponses[data.followCompositeKey] = [];
        }
        updatedResponses[data.followCompositeKey].push({
          user: data.user,
          bot: "",
        });
        return updatedResponses;
      });
      setFollowupQuestion("");
    });

    socket.on("followup-query-bot", (data) => {
      setFollowupResponses((prevResponses) => {
        const updatedResponses = { ...prevResponses };
        if (!updatedResponses[data.followCompositeKey]) {
          updatedResponses[data.followCompositeKey] = [];
        }
        const lastResponseIndex =
          updatedResponses[data.followCompositeKey].length - 1;
        if (lastResponseIndex >= 0) {
          updatedResponses[data.followCompositeKey][lastResponseIndex].bot +=
            data.bot;
        }
        return updatedResponses;
      });
    });
    socket.on("disconnect", () => {
      console.log("Socket Disconnected");
    });

    return () => {
      socket.off("connect");
      socket.off("ack");
      socket.off("login-success");
      socket.off("query-response-solution");
      socket.off("image-url");
      socket.off("question-text");
      socket.off("query-update-solution");
      socket.off("final-solution");
      socket.off("common-question-solution");
      socket.off("followup-query-user");
      socket.off("followup-query-bot");
      socket.off("error");
      socket.off("disconnect");
    };
  }, [stopRendering]);

  const isAndroidWebView = () => {
    return !!(window.AndroidWebView || navigator.userAgent.includes("wv"));
  };

  const sendDataToAndroid = () => {
    const data = "doubtSolve";
    if (window.AndroidNative) {
      window.AndroidNative.sendDataToNative(data);
    }
  };

  const sendDataToFlutter = () => {
    const data = "doubtSolve";
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler("sendDataToFlutter", data);
    }
  };

  function isDesktop() {
    return window.matchMedia("(min-width: 1024px)").matches;
  }

  const isIOSWebView = () => {
    return !!(window.webkit && window.webkit.messageHandlers);
  };

  const isWebView = () => {
    return isAndroidWebView() || isIOSWebView();
  };

  const checkForCamera = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      navigator.mediaDevices.enumerateDevices().then((devices) => {
        const videoDevices = devices.filter(
          (device) => device.kind === "videoinput",
        );
        if (videoDevices.length > 0) {
          setHasCamera(true);
          checkCameraPermissions();
        } else {
          setHasCamera(false);
          setAlertMessage("No camera available on this device.");
        }
      });
    } else {
      console.error("MediaDevices API is not supported in this browser.");
      setHasCamera(false);
      setAlertMessage("MediaDevices API is not supported in this browser.");
    }
  };

  const checkCameraPermissions = () => {
    if (useOld) {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          setPermissionDenied(false);
          stream.getTracks().forEach((track) => track.stop());
        })
        .catch((err) => {
          if (
            err.name === "NotAllowedError" ||
            err.name === "PermissionDeniedError"
          ) {
            setPermissionDenied(true);
            setAlertMessage(
              "Camera access denied. Please allow camera access.",
            );
          } else {
            console.error("Error accessing the camera:", err);
          }
        });
    } else {
      startup();
    }
  };

  const isRotationRequired = () => {
    return window.mode === "landscape";
  };

  const rotateCanvasImage = (canvas) => {
    var ctx = canvas.getContext("2d");
    const offscreenCanvas = document.createElement("canvas");
    const offscreenCtx = offscreenCanvas.getContext("2d");
    offscreenCanvas.width = canvas.width;
    offscreenCanvas.height = canvas.height;
    offscreenCtx.drawImage(canvas, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var originalCanvasWidth = canvas.width;
    var originalCanvasHeight = canvas.height;
    canvas.width = originalCanvasHeight;
    canvas.height = originalCanvasWidth;
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(-(Math.PI / 2));
    ctx.drawImage(
      offscreenCanvas,
      -offscreenCanvas.width / 2,
      -offscreenCanvas.height / 2,
    );
    ctx.resetTransform();
  };

  const onTakePicture = () => {
    var video = document.getElementById("video");
    var canvas = document.getElementById("canvas");
    var photo = document.getElementById("photo");
    var videoWidth = video.videoWidth;
    var videoHeight = video.videoHeight;
    var videoAspectRatio = videoWidth / videoHeight;
    var canvasWidth = videoWidth;
    var canvasHeight = canvasWidth / videoAspectRatio;
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    var context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(video, 0, 0, canvasWidth, canvasHeight);
    context.filter = "brightness(1.1) contrast(1.2)";
    if (isRotationRequired()) {
      rotateCanvasImage(canvas);
    }
    var data = canvas.toDataURL("image/png", 1.0);
    document.getElementById("camera").style.display = "none";
    document.getElementById("mainDiv").style["margin-top"] = "2%";
    setImage(data);
  };

  const startup = () => {
    document.getElementById("mainDiv").style["margin-top"] = "0px";
    document.getElementById("camera").style.display = "block";
    var video = document.getElementById("video");
    var canvas = document.getElementById("canvas");
    var photo = document.getElementById("photo");
    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: "environment",
          width: window.innerHeight,
          height: window.innerWidth,
        },
        audio: false,
      })
      .then(function (stream) {
        setPermissionDenied(false);
        video.srcObject = stream;
        video.play();
      })
      .catch((err) => {
        if (
          err.name === "NotAllowedError" ||
          err.name === "PermissionDeniedError"
        ) {
          setPermissionDenied(true);
          setAlertMessage("Camera access denied. Please allow camera access.");
        } else {
          console.error("Error accessing the camera:", err);
        }
      });
    video.addEventListener(
      "canplay",
      function () {
        video.style["padding-top"] =
          (window.innerHeight - video.offsetHeight) / 2 + "px";
      },
      false,
    );
  };

  useEffect(() => {
    if (alertMessage) {
      const timer = setTimeout(() => {
        setAlertMessage("");
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [alertMessage]);
  const handleFileUpload = useCallback(
    (source) => {
      if (!recaptchaToken) {
        console.error("No recaptchaToken, showing modal");
        setSubmissionSource(source);
        setShowRecaptchaModal(true);
        return;
      }
      setTextQuestion("");
      setShowCropArea(false);
      setFeedbackShow(false);
      if (image || textQuestion) {
        setQueries((prevQueries) => [
          ...prevQueries,
          { file: "", question: "", solution: "" },
        ]);
        if (image) {
          setTextQuestion("");
          if (cropperRef.current?.cropper) {
            const cropWidth = window.innerHeight;
            const cropHeight = window.innerWidth;
            const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas({
              width: cropWidth,
              height: cropHeight,
              imageSmoothingEnabled: true,
              imageSmoothingQuality: "high",
            });
            if (croppedCanvas) {
              croppedCanvas.toBlob(
                (blob) => {
                  if (blob) {
                    const file = new File([blob], orgFileName, {
                      type: "image/png",
                    });

                    // Convert to base64 for UI preview
                    const reader = new FileReader();
                    reader.onloadend = () => {
                      const base64Image = reader.result;

                      // update last query with this preview
                      setQueries((prev) => {
                        const updated = [...prev];
                        updated[updated.length - 1].image = base64Image;
                        return updated;
                      });
                    };
                    reader.readAsDataURL(file);

                    const fileContent = file;
                    const tokenToUse = recaptchaToken;
                    setRecaptchaToken("");
                    if (recaptchaRef.current) recaptchaRef.current.reset();
                    handleSocketEmit("image-query", {
                      fileContent: fileContent,
                      fileName: orgFileName,
                      recaptchaToken: tokenToUse,
                    });
                    setImage(null);
                  }
                },
                "image/png",
                1,
              );
            }
          }
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        } else if (textQuestion) {
          setImage(null);
          const tokenToUse = recaptchaToken;
          setRecaptchaToken("");
          if (recaptchaRef.current) recaptchaRef.current.reset();
          handleSocketEmit("text-query", {
            textQuestion: textQuestion,
            recaptchaToken: tokenToUse,
          });
        }
        setProcessing("processing");
        setLoading(true);
        setSubmissionSource(null);
        if (source === "Submit Button") {
          trackEvent(submit_image);
        } else if (source === "Icon Button") {
          trackEvent(SendButton);
        }
      } else {
        alert("Please select a question first.");
      }
    },
    [image, orgFileName, recaptchaToken, textQuestion],
  );
  // recaptchaToken

  const onChange = (e) => {
    e.preventDefault();
    let file;
    if (e.dataTransfer) {
      file = e.dataTransfer.files[0];
    } else if (e.target) {
      file = e.target.files[0];
    }
    if (file) {
      if (!isAllowedAttachment(file)) {
        toast.error("Only image and PDF files are allowed.");
        if (e.target && "value" in e.target) {
          e.target.value = "";
        }
        return;
      }
      setOrgFileName(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
        setShowCropArea(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!isAllowedAttachment(file)) {
        toast.error("Only image and PDF files are allowed.");
        event.target.value = "";
        return;
      }
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
      setOrgFileName(`db_chatbot_${Date.now()}.jpg`);
      return () => URL.revokeObjectURL(imageUrl);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setSubmissionSource("Icon Button"); // Treat Enter as Icon Button
      if (!recaptchaToken) {
        setShowRecaptchaModal(true);
      }
    }
    trackEvent(type_doubts);
  };

  const handleFollowupKeyPress = (e, line, compositeKey) => {
    if (e.key === "Enter") {
      e.preventDefault();
      followUpInputQuestions(line, compositeKey);
    }
  };

  const toggleStepVisibility = (questionIndex, stepIndex) => {
    const compositeKey = `${questionIndex}-${stepIndex}`;
    setVisibleSteps((prevState) => ({
      ...prevState,
      [compositeKey]: !prevState[compositeKey],
    }));
    setTimeout(() => {
      if (explanationRefs.current[compositeKey]) {
        explanationRefs.current[compositeKey].scrollIntoView({
          behavior: "smooth",
        });
      }
    }, 0);
  };

  const allClear = () => {
    setQueries([]);
    setCommonQuestionSolutions({});
    setFollowupResponses({});
    setFollowupInputQuestion({});
    setVisibleSteps({});
    setProcessing("");
    setFeedbackShow(true);
    setFeedbackDataShow(false);
    setThanksFeedBack(false);
  };

  const stopRenderingHandler = () => {
    setStopRendering(true);
    setLoading(false);
  };

  const handleCameraInput = () => {
    trackEvent(click_photo);
    setShowCropArea(true);
    if (!isAndroidWebView()) {
      document.getElementById("cameraInput").click();
    } else {
      checkForCamera();
    }
  };

  const cancelupload = (source) => {
    if (source === "cancel attach") {
      trackEvent(cancel_attach);
    }
  };

  const closeModal = () => {
    setImage(null);
    setOrgFileName("");
    setShowCropArea(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    trackEvent(cancel_image);
  };

  const commonQuestions = (line, questionIndex, stepIndex) => {
    const compositeKey = `${questionIndex}-${stepIndex}`;
    setSelectedLine(line);
    handleSocketEmit("common-question-query", {
      commonQuestion: line,
      indexValue: compositeKey,
      recaptchaToken: recaptchaToken,
    });
  };

  const handleFollowUpClick = (line, question, compositeKey) => {
    setFollowupQuestion(question);
    followUpQuestions(line, compositeKey, question);
  };

  const followUpQuestions = (line, compositeKey, question) => {
    handleSocketEmit("followup-query", {
      line: line,
      question: question,
      followCompositeKey: compositeKey,
      recaptchaToken: recaptchaToken,
    });
  };

  const followUpInputQuestions = (line, compositeKey) => {
    const question = followupInputQuestion[compositeKey];
    handleSocketEmit("followup-query", {
      line: line,
      question: question,
      followCompositeKey: compositeKey,
      recaptchaToken: recaptchaToken,
    });
    setFollowupInputQuestion((prev) => ({
      ...prev,
      [compositeKey]: "",
    }));
  };

  const maxLengthFollowup = 250;
  const handleFollowupInputChange = (e, compositeKey) => {
    const { value } = e.target;
    if (value.length < maxLengthFollowup) {
      setFollowupInputQuestion((prev) => ({
        ...prev,
        [compositeKey]: value,
      }));
      setFollowUpData(value);
    } else if (value.length >= maxLengthFollowup) {
      toast.warning(
        `maximum character limit ${followupInputQuestion[compositeKey].length}/${maxLengthFollowup}`,
      );
    }
  };

  const shouldShowFollowUpButton = (line) => {
    return [
      "Step 1:",
      "Step 2:",
      "Step 3:",
      "Step 4:",
      "Step 5:",
      "Step 6:",
      "Step 7:",
      "Step 8:",
      "Step 9:",
      "Step 10:",
    ].some((step) => line.startsWith(step));
  };

  const preprocessText = (text) => {
    return text.replace(/\*/g, "");
  };

  const extractStep = (text) => {
    const stepRegex = /Step\s+(\d+):/;
    const match = text.match(stepRegex);
    return match ? match[1] : null;
  };

  // The LLM formats each step as "Step N: <title>\n<content>". We show "Step N: <title>"
  // as the card header, so extractStepBody strips that first line out of the body to avoid
  // rendering the title twice (once in the header, once glued to the start of the content).
  const extractStepTitle = (text) => {
    const match = text.match(/Step\s+\d+:\s*([^\n]*)/);
    return match ? match[1].trim() : null;
  };

  const extractStepBody = (text) => {
    const newlineIndex = text.indexOf("\n");
    return newlineIndex === -1 ? "" : text.slice(newlineIndex + 1).trim();
  };

  const maxLength = 500;
  const handleChange = (e) => {
    const { value } = e.target;

    setImage(null);
    setShowCropArea(false);

    if (value.length < maxLength) {
      setTextQuestion(value);
    } else if (value.length >= maxLength) {
      toast.warning(
        `maximum character limit ${textQuestion.length}/${maxLength}`,
      );
    }
  };

  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      if (hasCamera === true) {
        setHasCamera(false);
      }
    };
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [hasCamera]);

  const renderObjectData = [
    {
      id: 1,
      imageData: "/microscope.png",
      textData: "Determine focal length of a convex length",
    },
    {
      id: 2,
      imageData: "/glass.png",
      textData: "Explain Cannizzaro reaction in details",
    },
    {
      id: 3,
      imageData: "/math.png",
      textData: "How to find the slope of a curve?",
    },
    {
      id: 4,
      imageData: "/DNA.png",
      textData: "Differentiate between mitosis and meiosis?",
    },
  ];

  const handleClickRenderObject = (data, id) => {
    if (!recaptchaToken) {
      setSubmissionSource({ type: "Suggestion", data, id });
      setShowRecaptchaModal(true);
      return;
    }
    setQueries((prevQueries) => [
      ...prevQueries,
      { file: "", question: "", solution: "" },
    ]);
    const numericId = Number(id + 1);
    const tokenToUse = recaptchaToken;
    setRecaptchaToken("");
    if (recaptchaRef.current) recaptchaRef.current.reset();
    handleSocketEmit("text-query", {
      textQuestion: data.textData,
      recaptchaToken: tokenToUse,
    });

    setProcessing("processing");
    setLoading(true);
    setFeedbackShow(false);
    setShowRecaptchaModal(false);
    if (numericId === 1) {
      trackEvent(Suggestion_1st);
    } else if (numericId === 2) {
      trackEvent(Suggestion_2nd);
    } else if (numericId >= 3) {
      trackEvent(other_Suggestion);
    }
  };

  const handleClickRenderObject2 = (data, id) => {
    if (!recaptchaToken) {
      setSubmissionSource({ type: "Suggestion2", data, id });
      setShowRecaptchaModal(true);
      return;
    }
    setQueries((prevQueries) => [
      ...prevQueries,
      { file: "", question: "", solution: "" },
    ]);
    const numericId = Number(id + 1);
    const tokenToUse = recaptchaToken;
    setRecaptchaToken("");
    if (recaptchaRef.current) recaptchaRef.current.reset();
    handleSocketEmit("text-query", {
      textQuestion: data.question,
      recaptchaToken: tokenToUse,
    });
    setProcessing("processing");
    setLoading(true);
    setFeedbackShow(false);
    setShowRecaptchaModal(false);
    if (numericId === 1) {
      trackEvent(Suggestion_1st);
    } else if (numericId === 2) {
      trackEvent(Suggestion_2nd);
    } else if (numericId >= 3) {
      trackEvent(other_Suggestion);
    }
  };

  const handleFeedback = (data) => {
    setThanksFeedBack(true);
    if (doubtId) {
      handleSocketEmit("student-feedback", {
        doubtId,
        feedback: data,
      });
    }
    if (data === "Yes") {
      trackEvent(yes_feedback);
    } else if (data === "No") {
      trackEvent(no_feedback);
    }
  };

  const handleAskAnotherDoubt = () => {
    setQueries([]);
    setCommonQuestionSolutions({});
    setFollowupResponses({});
    setFollowupInputQuestion({});
    setVisibleSteps({});
    setProcessing("");
    setRecaptchaToken("");
    setShowRecaptchaModal(false);
    setFeedbackShow(true);
    setFeedbackDataShow(false);
    setThanksFeedBack(false);
    setSubmissionSource(null);
    trackEvent(ask_another_doubt);
  };

  useEffect(() => {
    if (!showRecaptchaModal && recaptchaToken && submissionSource) {
      if (submissionSource.type === "Suggestion") {
        handleClickRenderObject(submissionSource.data, submissionSource.id);
      } else if (submissionSource.type === "Suggestion2") {
        handleClickRenderObject2(submissionSource.data, submissionSource.id);
      } else {
        handleFileUpload(submissionSource);
      }
    }
  }, [
    showRecaptchaModal,
    recaptchaToken,
    submissionSource,
    handleFileUpload,
    handleClickRenderObject,
    handleClickRenderObject2,
  ]);

  const accentColor = partnerData.primaryColor || "hsla(224, 73%, 49%, 1)";

  return (
    <div
      className={`chat-app ${!processing ? "is-empty" : ""}`}
      style={{ overflowY: "auto", maxHeight: "100vh" }}
    >
      {notLogin ? <Loader /> : null}
      {returningApiKey ? (
        <div id="mainDiv" className="mainDiv">
          <>
            <div className="camera" id="camera" style={{ display: "none" }}>
              <video
                id="video"
                autoPlay
                muted
                playsInline
                preload="auto"
                poster="/ps.png"
              >
                Video stream not available.
              </video>
              <div className="cameraDiv">
                <button
                  className="btn btn-primary btnFont cameraBtn"
                  style={{ zIndex: "99999" }}
                  onClick={() => {
                    onTakePicture();
                    setOrgFileName(`db_chatbot_${Date.now()}.jpg`);
                  }}
                >
                  <i className="bi bi-camera"></i>
                </button>
              </div>
            </div>
            <canvas id="canvas" style={{ display: "none" }}></canvas>
            <img
              id="photo"
              style={{ display: "none", objectFit: "cover" }}
              alt=""
            />
          </>

          <header className="app-header">
            <div className="app-brand">
              <img
                className="app-brand-logo"
                src="/logo.svg"
                alt="AI Chat"
                width={94}
                height={30}
              />
            </div>
            <button
              type="button"
              className="theme-toggle-btn"
              onClick={toggleTheme}
              aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            >
              {isDark ? (
                <LightModeOutlinedIcon sx={{ fontSize: 20 }} />
              ) : (
                <DarkModeOutlinedIcon sx={{ fontSize: 20 }} />
              )}
            </button>
          </header>
          <div className="mainDivTwo mx-auto">
            {processing ? (
              <div>
                <div className="imageFormate">
                  {queries.map((query, questionIndex) => (
                    <div key={questionIndex} className="queryBlock">
                      {query.image ? (
                        <div className="imageDiv">
                          <img
                            src={query.image}
                            alt=""
                            style={{ width: "100%" }}
                          />
                        </div>
                      ) : null}
                      {query.question ? (
                        <div className="questionDiv">
                          <h6 className="mb-0">
                            <MathJax.Context
                              input="tex"
                              options={mathJaxConfig}
                            >
                              <div className="d-flex">
                                <span className="qDiv">Q.</span>
                                <div style={{ wordSpacing: "3px" }}>
                                  <SafeMathJaxText content={query?.question} />
                                </div>
                              </div>
                            </MathJax.Context>
                          </h6>
                        </div>
                      ) : null}
                      {query.solution ? (
                        <div>
                          <h4 className="solutionNameHead mb-0">Solution</h4>
                          {loading ? (
                            // During streaming — show raw text so user sees it appear word by word
                            <pre className="solution-text">
                              <MathJax.Context
                                input="tex"
                                options={mathJaxConfig}
                              >
                                <SafeMathJaxText
                                  content={preprocessText(query.solution)}
                                />
                              </MathJax.Context>
                            </pre>
                          ) : (
                            // After streaming complete — show full structured step view
                            <MathJax.Context
                              input="tex"
                              options={mathJaxConfig}
                            >
                              <div>
                                {query.solution
                                  .split(/### |#### /)
                                  .map((line) => line.trim())
                                  .filter((line) => line !== "")
                                  .map((line, stepIndex) => {
                                    const compositeKey = `${questionIndex}-${stepIndex}`;
                                    const preprocessedLine =
                                      preprocessText(line);
                                    const stepNumber = extractStep(line);
                                    const isStep = shouldShowFollowUpButton(
                                      preprocessedLine,
                                    );
                                    const stepTitle = isStep
                                      ? extractStepTitle(preprocessedLine)
                                      : null;
                                    const bodyContent = isStep
                                      ? extractStepBody(preprocessedLine)
                                      : preprocessedLine;
                                    return (
                                      <div key={stepIndex}>
                                        <div className="solutionDiv">
                                          <pre className="solution-text">
                                            <div
                                              ref={(el) =>
                                                (explanationRefs.current[
                                                  compositeKey
                                                ] = el)
                                              }
                                            >
                                              {isStep && (
                                                <div className="d-flex align-items-center justify-content-between mb-1">
                                                  <div>
                                                    <h6 className="solution-step-title">
                                                      Step{" "}
                                                      {stepNumber && stepNumber}
                                                      {stepTitle
                                                        ? `: ${stepTitle}`
                                                        : ":"}
                                                    </h6>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                            <SafeMathJaxText
                                              content={bodyContent}
                                            />
                                          </pre>
                                          <div
                                            className="stepAskDiv"
                                            style={{
                                              display: visibleSteps[
                                                compositeKey
                                              ]
                                                ? "block"
                                                : "none",
                                            }}
                                          >
                                            {/* all the follow-up buttons — unchanged */}
                                            <div className="talkDiv">
                                              <div className="followup-panel">
                                                <div className="followup-panel-header">
                                                  <p className="followup-panel-label">
                                                    Need help with this step?
                                                  </p>
                                                </div>
                                                <div className="followup-panel-body">
                                                <div className="followup-quick-actions">
                                                  <button
                                                    type="button"
                                                    className="followup-chip followup-chip-action"
                                                    onClick={() => {
                                                      handleFollowUpClick(
                                                        line,
                                                        "Ask a question",
                                                        compositeKey,
                                                      );
                                                      trackEvent(followup_question);
                                                    }}
                                                  >
                                                    <span className="followup-chip-icon">
                                                      <i className="bi bi-chat-left-text"></i>
                                                    </span>
                                                    <span>Ask a question</span>
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className="followup-chip followup-chip-action"
                                                    onClick={() => {
                                                      handleFollowUpClick(
                                                        line,
                                                        "Help. I'm lost",
                                                        compositeKey,
                                                      );
                                                      trackEvent(followup_question);
                                                    }}
                                                  >
                                                    <span className="followup-chip-icon">
                                                      <i className="bi bi-life-preserver"></i>
                                                    </span>
                                                    <span>Help, I'm lost</span>
                                                  </button>
                                                </div>
                                                {commonQuestionSolutions[
                                                  compositeKey
                                                ]?.length > 0 ? (
                                                  <>
                                                    <p className="followup-panel-sublabel">
                                                      Suggested questions
                                                    </p>
                                                    <div className="followup-suggestions">
                                                      {commonQuestionSolutions[
                                                        compositeKey
                                                      ].map(
                                                        (question, qIndex) => (
                                                          <button
                                                            type="button"
                                                            key={qIndex}
                                                            className="followup-chip followup-chip-question"
                                                            onClick={() => {
                                                              handleFollowUpClick(
                                                                line,
                                                                question,
                                                                compositeKey,
                                                              );
                                                              trackEvent(
                                                                followup_question,
                                                              );
                                                            }}
                                                          >
                                                            <span className="followup-chip-text">
                                                              <MathJax.Text
                                                                text={question}
                                                              />
                                                            </span>
                                                            <i className="bi bi-arrow-right followup-chip-arrow"></i>
                                                          </button>
                                                        ),
                                                      )}
                                                    </div>
                                                  </>
                                                ) : null}
                                                {followupResponses[
                                                  compositeKey
                                                ]?.length > 0 ? (
                                                  <div className="followup-thread">
                                                    {followupResponses[
                                                      compositeKey
                                                    ].map(
                                                      (response, index) => (
                                                        <div key={index}>
                                                          <div className="d-flex justify-content-end">
                                                            <div className="askQuestion">
                                                              <div>
                                                                <h6 className="bubble-label">
                                                                  You
                                                                </h6>
                                                              </div>
                                                              <div>
                                                                <pre>
                                                                  <SafeMathJaxText
                                                                    content={
                                                                      response.user
                                                                    }
                                                                  />
                                                                </pre>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div className="d-flex justify-content-start">
                                                            <div className="aiSolution">
                                                              <h6 className="bubble-label">
                                                                AI
                                                              </h6>
                                                              <div>
                                                                <pre>
                                                                  <SafeMathJaxText
                                                                    content={
                                                                      response.bot
                                                                    }
                                                                  />
                                                                </pre>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      ),
                                                    )}
                                                  </div>
                                                ) : null}
                                                <div className="followupInputDiv d-flex align-items-center w-100">
                                                  <input
                                                    type="text"
                                                    className="followupInput"
                                                    value={
                                                      followupInputQuestion[
                                                        compositeKey
                                                      ] || ""
                                                    }
                                                    onChange={(e) =>
                                                      handleFollowupInputChange(
                                                        e,
                                                        compositeKey,
                                                      )
                                                    }
                                                    onKeyPress={(e) =>
                                                      handleFollowupKeyPress(
                                                        e,
                                                        line,
                                                        compositeKey,
                                                      )
                                                    }
                                                    placeholder="Type your follow-up question"
                                                    maxLength={
                                                      maxLengthFollowup
                                                    }
                                                  />
                                                  <button
                                                    type="button"
                                                    className="followup-send-btn"
                                                    onClick={() =>
                                                      followUpInputQuestions(
                                                        line,
                                                        compositeKey,
                                                      )
                                                    }
                                                  >
                                                    {followUpData &&
                                                    followUpData.length > 0 ? (
                                                      <SendIcon
                                                        sx={{
                                                          color:
                                                            "var(--chat-accent)",
                                                          fontSize: 28,
                                                        }}
                                                      />
                                                    ) : (
                                                      <img
                                                        className="frontIcons"
                                                        src="/send.png"
                                                        alt=""
                                                      />
                                                    )}
                                                  </button>
                                                </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </MathJax.Context>
                          )}
                        </div>
                      ) : null}
                      {!query.question && query.solution ? (
                        <div className="noQuestionFound mb-4"></div>
                      ) : null}
                    </div>
                  ))}
                </div>
                {processing && loading && (
                  <div className="ai-thinking">
                    <h6>{processing}</h6>

                    <div className="dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <>
                {showModal && (partnerData?.popup ?? 0) === 1 ? (
                  <FreeFinish2
                    showModal={showModal}
                    setShowModal={setShowModal}
                    FreeDoubt={FreeDoubt}
                    codeSnippet={codeSnippet}
                    freeFinishProps={freeFinishProps}
                  />
                ) : (
                  <FreeFinish
                    showModal={showModal}
                    setShowModal={setShowModal}
                    FreeDoubt={FreeDoubt}
                    codeSnippet={codeSnippet}
                    freeFinishProps={freeFinishProps}
                  />
                )}
                <div
                  className="frontScreen"
                  style={{ display: showModal === true ? "none" : "flex" }}
                >
                  <h1 className="empty-greeting">How can I help today?</h1>
                </div>
              </>
            )}
          </div>
          {showCropArea && (
            <div className="d-flex align-items-center justify-content-center mx-auto flex-column">
              {image ? (
                <div className="cropDiv">
                  <div
                    style={{
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                      overflow: "scroll",
                    }}
                  >
                    <Cropper
                      ref={cropperRef}
                      style={{ width: "100%", maxHeight: "70vh" }}
                      zoomTo={0}
                      initialAspectRatio={1}
                      preview=".img-preview"
                      src={image}
                      viewMode={1}
                      minCropBoxHeight={10}
                      minCropBoxWidth={10}
                      background={false}
                      responsive={true}
                      autoCropArea={1}
                      checkOrientation={false}
                      dragMode="none"
                      guides={true}
                      touchDragZoom={true}
                      zoomable={true}
                      scalable={true}
                      rotatable={true}
                    />
                  </div>
                  <div className="cropAreaFooter">
                    <button
                      type="button"
                      className="btn btn-sm crop-cancel-btn"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-sm"
                      style={{
                        backgroundColor: partnerData.primaryColor
                          ? partnerData.primaryColor
                          : "#2454dd",
                        color: "#ffff",
                      }}
                      onClick={() => handleFileUpload("Submit Button")}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              ) : (
                <div className="cameraBody">
                  {hasCamera ? (
                    <div className="cameraBody">
                      {!permissionDenied ? (
                        <div className="cameraOpen">
                          {isAndroidWebView() ? (
                            <>
                              {useOld ? (
                                <>
                                  <Camera
                                    ref={cameraRef}
                                    facingMode="environment"
                                    isImageMirror={false}
                                  />
                                  <div className="cameraDiv">
                                    <button
                                      className="btn btn-primary btnFont cameraBtn"
                                      onClick={() => {
                                        setImage(cameraRef.current.takePhoto());
                                        setOrgFileName(
                                          `db_chatbot_${Date.now()}.jpg`,
                                        );
                                      }}
                                    >
                                      <i className="bi bi-camera"></i>
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      ) : (
                        alertMessage && (
                          <div
                            className="noCamera alert alert-warning alert-dismissible fade show"
                            role="alert"
                          >
                            <p className="m-0 p-0">{alertMessage}</p>
                            <button
                              type="button"
                              className="btn btn-sm p-1"
                              data-bs-dismiss="alert"
                              aria-label="Close"
                              onClick={() => setAlertMessage("")}
                            >
                              <i className="bi bi-x-circle"></i>
                            </button>
                          </div>
                        )
                      )}
                    </div>
                  ) : (
                    alertMessage && (
                      <div
                        className="noCamera alert alert-warning alert-dismissible fade show"
                        role="alert"
                      >
                        <p className="m-0 p-0">{alertMessage}</p>
                        <button
                          type="button"
                          className="btn btn-sm p-1"
                          data-bs-dismiss="alert"
                          aria-label="Close"
                          onClick={() => setAlertMessage("")}
                        >
                          <i className="bi bi-x-circle"></i>
                        </button>
                      </div>
                    )
                  )}
                </div>
              )}
            </div>
          )}
          {feedbackShow ? (
            <div className="bottomArea">
              <div
                className="selectFile composer"
                style={{ borderColor: accentColor }}
              >
                {isValidUser && (
                  <React.Fragment>
                    <input
                      type="file"
                      id="file-crop"
                      onChange={(e) => {
                        setShowAttachMenu(false);
                        onChange(e);
                      }}
                      accept="image/*,application/pdf"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                    />
                    {!isAndroidWebView() && (
                      <input
                        ref={cameraRef}
                        type="file"
                        id="cameraInput"
                        accept="image/*"
                        onChange={(e) => {
                          setShowAttachMenu(false);
                          handleFileChange(e);
                        }}
                        capture="camera"
                        style={{ display: "none" }}
                      />
                    )}
                    <textarea
                      rows="2"
                      className="inputArea textQuestion"
                      placeholder={
                        partnerData.placeholderText
                          ? partnerData.placeholderText
                          : "Ask me anything"
                      }
                      type="text"
                      value={textQuestion}
                      onChange={handleChange}
                      onKeyPress={handleKeyPress}
                      maxLength={maxLength}
                    />
                    <div className="composer-toolbar">
                      {Number(partnerData?.showAttachments ?? 1) === 1 && (
                        <div className="attach-wrap" ref={attachMenuRef}>
                          <button
                            className="composer-icon-btn"
                            type="button"
                            aria-label="Add attachment"
                            onClick={() => {
                              trackEvent(attach_icon);
                              setShowAttachMenu((open) => !open);
                            }}
                          >
                            <AddIcon sx={{ fontSize: 22 }} />
                          </button>
                          {showAttachMenu && (
                            <div className="attach-menu">
                              <button
                                type="button"
                                className="attach-menu-item"
                                onClick={() => {
                                  setShowAttachMenu(false);
                                  handleCameraInput();
                                }}
                              >
                                <PhotoCameraOutlinedIcon sx={{ fontSize: 18 }} />
                                Click a Photo
                              </button>
                              <label
                                htmlFor="file-crop"
                                className="attach-menu-item"
                                onClick={() => trackEvent(upload_document)}
                              >
                                <ImageOutlinedIcon sx={{ fontSize: 18 }} />
                                Upload image
                              </label>
                            </div>
                          )}
                        </div>
                      )}
                      <div className="composer-toolbar-right">
                        <button
                          className="composer-icon-btn"
                          type="button"
                          aria-label="Voice input"
                          disabled
                          title="Voice input coming soon"
                        >
                          <MicNoneIcon sx={{ fontSize: 22 }} />
                        </button>
                        {processing && loading ? (
                          <button
                            onClick={stopRenderingHandler}
                            className="composer-send-btn"
                            type="button"
                            aria-label="Stop"
                            style={{ backgroundColor: accentColor }}
                          >
                            <i className="bi bi-stop-circle"></i>
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              if (image || textQuestion) {
                                setSubmissionSource("Icon Button");
                                if (!recaptchaToken) {
                                  setShowRecaptchaModal(true);
                                }
                              }
                            }}
                            className="composer-send-btn"
                            type="button"
                            aria-label="Send"
                            style={{
                              backgroundColor: accentColor,
                              borderColor: accentColor,
                            }}
                          >
                            <NorthIcon sx={{ color: "#fff", fontSize: 18 }} />
                          </button>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
          ) : (
            <>
              {(() => {
                const showFeedback = Number(partnerData?.showFeedback ?? 1); // Default: show feedback
                const color = partnerData?.primaryColor || "hsla(224, 73%, 49%, 1)";

                // Case 1: Feedback enabled
                if (showFeedback === 1 && feedbackDataShow) {
                  return (
                    <div className="bottomArea">
                      <div className="selectFile1">
                        {thanksFeedBack ? (
                          <div className="thankdFeedBackDiv">
                            <div className="FeedBackDiv">
                              🙏 Thank you for the feedback!
                            </div>
                            <button
                              type="button"
                              className="Ask_Another_Doubt"
                              style={{ backgroundColor: color }}
                              onClick={handleAskAnotherDoubt}
                            >
                              Ask another Doubt
                            </button>
                          </div>
                        ) : (
                          <div className="helpulDiv1">
                            <div className="helpulDiv">
                              <div>
                                <h5 className="was_helpful">
                                  Was this helpful?
                                </h5>
                              </div>
                              <div className="feedBack-Button">
                                <button
                                  type="button"
                                  className="green-button"
                                  onClick={() => handleFeedback("Yes")}
                                >
                                  <i className="bi bi-hand-thumbs-up"></i> Yes
                                </button>
                                <button
                                  type="button"
                                  className="red-button"
                                  onClick={() => handleFeedback("No")}
                                >
                                  <i
                                    className="bi bi-hand-thumbs-down"
                                    style={{ marginTop: "2px" }}
                                  ></i>{" "}
                                  No
                                </button>
                              </div>
                            </div>
                            <button
                              type="button"
                              className="Ask_Another_Doubt"
                              style={{ backgroundColor: color }}
                              onClick={handleAskAnotherDoubt}
                            >
                              Ask another Doubt
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }

                // Case 2: Feedback disabled but data show is true
                if (showFeedback === 0 && feedbackDataShow) {
                  return (
                    <div className="bottomArea">
                      <div className="selectFile1">
                        <button
                          type="button"
                          className="Ask_Another_Doubt"
                          style={{ backgroundColor: color }}
                          onClick={handleAskAnotherDoubt}
                        >
                          Ask another Doubt
                        </button>
                      </div>
                    </div>
                  );
                }

                // Default: Nothing to show
                return null;
              })()}
            </>
          )}
          {showRecaptchaModal && (
            <div
              className="recaptcha-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="recaptcha-modal-title"
            >
              <div className="recaptcha-modal-content">
                <h2 id="recaptcha-modal-title" className="recaptcha-modal-title">
                  Please verify
                </h2>
                <p className="recaptcha-modal-subtitle">
                  Complete the check below to continue.
                </p>
                <div className="recaptcha-modal-widget">
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    ref={recaptchaRef}
                    theme={isDark ? "dark" : "light"}
                    onChange={(token) => {
                      setRecaptchaToken(token);
                      setShowRecaptchaModal(false);
                    }}
                    onExpired={() => {
                      console.log("reCAPTCHA expired");
                      setRecaptchaToken("");
                      setShowRecaptchaModal(true);
                      toast.error("Verification expired, please try again");
                    }}
                    onErrored={() => {
                      console.error("reCAPTCHA error occurred");
                      setRecaptchaToken("");
                      setShowRecaptchaModal(true);
                      toast.error("Verification failed, please try again");
                      if (recaptchaRef.current) {
                        recaptchaRef.current.reset();
                      }
                    }}
                  />
                </div>
                <div className="recaptcha-modal-actions">
                  <button
                    type="button"
                    className="recaptcha-modal-cancel"
                    onClick={() => {
                      console.log("reCAPTCHA modal cancelled");
                      setShowRecaptchaModal(false);
                      setRecaptchaToken("");
                      setSubmissionSource(null);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          <ToastContainer
            position="top-right"
            autoClose={1500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={isDark ? "dark" : "light"}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default Home;
